// @ts-nocheck
// Type annotations are now using JSDoc comments for better TypeScript compatibility in JS files

// Ensure theme is defined
const theme = window.theme || {};

if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    sticky;
    updateUrl;
    isDisabledFeature;
    other;
    productWrapper;
    productSlider;
    thumbnails;
    hideVariants;
    currentVariant;
    fieldsets;
    options;
    variantData;
    imageSetName;
    imageSetIndex;

    constructor() {
      super();
      // Initialize properties
      this.sticky = this.dataset?.sticky || null;
      this.updateUrl = this.dataset?.updateUrl === 'true';
      this.isDisabledFeature = this.dataset?.isDisabled || null;
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper ? this.productWrapper.querySelector('.product-images') : null;
      this.thumbnails = this.productWrapper ? this.productWrapper.querySelector('.product-thumbnail-container') : null;
      this.hideVariants = this.dataset?.hideVariants === 'true';
      this.currentVariant = null;
      this.fieldsets = [];
      this.options = [];
      this.variantData = null;
      this.imageSetName = null;
      this.imageSetIndex = null;
      this.addEventListener('change', this.onVariantChange);
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();

      // Ensure initial selected styles are set when component is loaded
      setTimeout(() => {
        this.updateSelectedStyles();
      }, 0);
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }

      this.updateOther();

      // Update selected styles after all changes are complete
      // Use setTimeout to ensure DOM is updated before applying styles
      setTimeout(() => {
        this.updateSelectedStyles();
      }, 0);

      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    /**
     * Updates the selected options from the fieldsets
     * @returns {void}
     */
    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (!fieldset) return;

        const selectElement = fieldset.querySelector('select');
        if (selectElement) {
          this.options.push(selectElement.value || '');
        } else {
          const checkedInput = fieldset.querySelector('input:checked');
          if (checkedInput) {
            this.options.push(checkedInput.value || '');
          }
        }
      });
      // Ensure options is always an array
      this.options = Array.isArray(this.options) ? this.options : [];
    }
    /**
     * Updates the variant text labels
     * @returns {void}
     */
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i] || '';
        }
      });
    }
    /**
     * Updates the current variant based on selected options
     * @returns {void}
     */
    updateMasterId() {
      const variantData = this.getVariantData();
      this.currentVariant = variantData.find((variant) => {
        if (!variant.options || !Array.isArray(variant.options) || variant.options.length !== this.options.length) {
          return false;
        }
        return variant.options.every((option, index) => {
          return this.options[index] === option;
        });
      }) || null;
    }

    /**
     * Updates other variant selects on the page
     * @returns {void}
     */
    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            const select = fieldsets_array[i].querySelector(`select`);
            select.value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            const input = fieldsets_array[i].querySelector(`input[value='${option}']`);
            input.checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    /**
     * Updates the product media based on selected variant
     * @returns {void}
     */
    updateMedia() {
      if (!this.currentVariant) return;

      const productWrapper = this.productWrapper;
      if (!productWrapper) return;

      // Get all variant-specific slide items and remove active class
      const allVariantItems = productWrapper.querySelectorAll('.product-images__slide-item--variant');
      Array.from(allVariantItems).forEach((item) => {
        item.classList.remove('is-active');
      });

      // Get all slides and thumbnails and remove active class
      const allSlides = productWrapper.querySelectorAll('.product-images__slide, .product-thumbnail');
      Array.from(allSlides).forEach((slide) => {
        slide.classList.remove('is-active', 'is-initial-selected');
      });

      // Handle German locale specifically
      const isGermanLocale = document.documentElement.lang === 'de';
      const hasGermanImages = productWrapper.querySelector('[data-media-id*="de-"]');
      const productSliderContainer = this.productSlider;
      const sliderElement = productWrapper.querySelector('product-slider');
      const thumbnails = productWrapper.querySelector('.product-thumbnail-container');

      if (isGermanLocale && hasGermanImages && this.currentVariant) {
        // For German locale, use variant index to select image
        const germanSlides = productWrapper.querySelectorAll('[data-media-id*="de-"]');
        const germanThumbnails = productWrapper.querySelectorAll('.product-thumbnail[data-media-id*="de-"]');

        if (germanSlides.length > 0) {
          // Find current variant index
          const variants = this.getVariantData();
          const currentVariantIndex = variants.findIndex((variant) =>
            variant.id === this.currentVariant?.id
          );

          // Calculate image index (cycle through images if more variants than images)
          const imageIndex = Math.max(0, currentVariantIndex % germanSlides.length);

          // Get the selected slide and thumbnail
          const selectedSlide = germanSlides[imageIndex];
          const selectedThumbnail = germanThumbnails[imageIndex];

          if (selectedSlide) {
            // Add active class to the selected slide
            selectedSlide.classList.add('is-active', 'is-initial-selected');

            // Add active class to the variant item within the slide
            const variantItem = selectedSlide.querySelector('.product-images__slide-item--variant');
            if (variantItem) {
              variantItem.classList.add('is-active');
            }

            // Update slider to show the selected slide
            if (sliderElement?.selectCell) {
              sliderElement.selectCell(imageIndex);
            } else if (sliderElement?.flkty) {
              sliderElement.flkty.select(imageIndex);
            } else if (productSliderContainer) {
              const flkty = window.Flickity?.data(productSliderContainer);
              if (flkty) {
                const allProductSlides = Array.from(productWrapper.querySelectorAll('.product-images__slide'));
                const slideIndex = allProductSlides.indexOf(selectedSlide);
                if (slideIndex !== -1) {
                  flkty.select(slideIndex);
                }
              }
            }
          }

          if (selectedThumbnail) {
            selectedThumbnail.classList.add('is-active');
          }
        }
      } else if (this.currentVariant.featured_media) {
        // For other languages, use the default logic
        const mediaId = `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
        const thumbId = `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
        this.setActiveMedia(mediaId, thumbId, sliderElement, thumbnails);
      }
    }
    /**
     * Sets the active media for the product
     * @param {string} mediaId - ID of the media element to activate
     * @param {string} thumbId - ID of the thumbnail element to activate
     * @param {HTMLElement|null} productSlider - Product slider element
     * @param {HTMLElement|null} thumbnails - Thumbnails container element
     * @returns {void}
     */
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      if (!productSlider) return;

      const flkty = window.Flickity?.data(productSlider);
      const activeMedia = productSlider.querySelector(mediaId);

      if (flkty && this.hideVariants && activeMedia) {
        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected')?.classList.remove('is-initial-selected');
        }
        const variantItems = productSlider.querySelectorAll('.product-images__slide-item--variant');
        Array.from(variantItems).forEach((el) => {
          el.classList.remove('is-active');
        });

        // Handle thumbnails
        if (this.thumbnails?.parentNode) {
          const thumbnailContainer = this.thumbnails;
          if (thumbnailContainer.querySelector('.product-thumbnail.is-initial-selected')) {
            thumbnailContainer.querySelector('.product-thumbnail.is-initial-selected')?.classList.remove('is-initial-selected');
          }
          const thumbnailVariantItems = thumbnailContainer.querySelectorAll('.product-images__slide-item--variant');
          Array.from(thumbnailVariantItems).forEach((el) => {
            el.classList.remove('is-active');
          });
        }

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        // Also add active class to the variant item within the slide
        const variantItem = activeMedia.querySelector('.product-images__slide-item--variant');
        if (variantItem) {
          variantItem.classList.add('is-active');
        }

        // Add null check for setImageSetMedia
        if (typeof this.setImageSetMedia === 'function') {
          this.setImageSetMedia();
        }

        if (thumbnails) {
          const activeThumb = thumbnails.querySelector(thumbId);
          if (activeThumb) {
            activeThumb.classList.add('is-active');
            activeThumb.classList.add('is-initial-selected');
          }
        }

        if (productSlider.reInit) {
          productSlider.reInit(this.imageSetIndex ? parseInt(this.imageSetIndex) : undefined);
        }
        if (productSlider.selectCell) {
          productSlider.selectCell(mediaId);
        }

      } else if (flkty && productSlider.selectCell) {
        productSlider.selectCell(mediaId);
      }
    }

    /**
     * Updates the URL with the selected variant ID
     * @returns {void}
     */
    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    /**
     * Updates the share URL with the selected variant ID
     * @returns {void}
     */
    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant?.id}`);
    }

    /**
     * Updates the variant input field with the selected variant ID
     * @returns {void}
     */
    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      Array.from(productForms).forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (input && this.currentVariant) {
          input.value = this.currentVariant.id.toString();
          input.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }
      });
    }

    /**
     * Updates the pickup availability information
     * @returns {void}
     */
    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Removes error messages from the product form
     * @returns {void}
     */
    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) {
        productForm.handleErrorMessage();
      }
    }

    /**
     * Gets the sections to render when variant changes
     * @returns {Array<string>} - Array of section IDs to render
     */
    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      if (!this.currentVariant) return;

      const sectionId = this.dataset.section;
      if (!sectionId) return;

      let sections = this.getSectionsToRender();
      if (!Array.isArray(sections)) return;

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${sectionId}`)
        .then((response) => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.text();
        })
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          sections.forEach((id) => {
            if (!id) return;
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings?.soldOut || 'Sold out');

        })
        .catch((error) => {
          console.error('Error fetching product info:', error);
        });
    }

    /**
     * Toggles the add to cart button state
     * @param {boolean} disable - Whether to disable the button
     * @param {string|boolean} text - Text to display on the button
     * @param {boolean} modifyClass - Whether to modify classes
     * @returns {void}
     */
    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form')?.getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons.length) return;
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (typeof text === 'string') {
            submitButtonText.textContent = text;
          }
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme?.variantStrings?.preOrder || 'Pre-order';
          } else {
            submitButtonText.textContent = window.theme?.variantStrings?.addToCart || 'Add to cart';
          }
        }
      });

      if (!modifyClass) return;
    }

    /**
     * Sets the product as unavailable
     * @returns {void}
     */
    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (submitButtonText) {
          submitButtonText.textContent = window.theme?.variantStrings?.unavailable || 'Unavailable';
          submitButton.classList.add('sold-out');
        }
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    /**
     * Sets the disabled state for unavailable options
     * @returns {boolean} - Whether the disabled state was set
     */
    setDisabled() {
      if (this.isDisabledFeature !== 'true') {
        return false;
      }
      const variant_data = this.getVariantData();

      if (!variant_data || !Array.isArray(variant_data)) {
        return false;
      }

      let selected_options = [];
      if (this.currentVariant && this.currentVariant.options && Array.isArray(this.currentVariant.options)) {
        selected_options = this.currentVariant.options.map((value, index) => {
          return {
            value,
            index: `option${index + 1}`
          };
        });
      } else {
        if (!this.options || !this.options[0]) {
          return false;
        }
        const found_option = variant_data.find(option => {
          return option && option.option1 === this.options[0];
        });
        if (found_option) {
          selected_options = [
            {
              "value": this.options[0],
              "index": "option1"
            },
            {
              "value": found_option.option2 || '',
              "index": "option2"
            }
          ];
        } else {
          return false;
        }
      }

      if (!Array.isArray(selected_options)) {
        return false;
      }

      const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

      this.fieldsets.forEach((fieldset, i) => {
        const fieldset_options = Object.values(available_options)[i];

        if (fieldset_options) {
          if (fieldset.querySelector('select')) {
            fieldset_options.forEach((option) => {
              const optionElement = fieldset.querySelector(`option[value=${JSON.stringify(option.value)}]`);
              if (optionElement) {
                optionElement.disabled = option.isUnavailable;
              }
            });
          } else if (fieldset.querySelectorAll('input').length) {
            fieldset.querySelectorAll('input').forEach((input) => {
              const option = fieldset_options.find(opt => opt.value === input.value);
              if (option) {
                input.classList.toggle('is-disabled', option.isUnavailable);
                this.updateOptionStyle(input, option.isUnavailable);
              }
            });
          }
        }
      });

      return true;
    }

    getImageSetName(variant_name) {
      if (variant_name === undefined || variant_name === null) {
        return '';
      }
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      // Check if we're on German locale and using German images
      const isGermanLocale = document.documentElement.lang === 'de';
      const hasGermanImages = this.product_container?.querySelector('[data-media-id*="de-"]');

      // Skip image set logic for German locale with custom images
      if (isGermanLocale && hasGermanImages) {
        return;
      }

      if (!this.imageSetIndex || !this.imageSetName) {
        return;
      }

      const setValue = this.getImageSetName(this.currentVariant?.[this.imageSetIndex]);
      const group = `${this.imageSetName}_${setValue}`;

      if (this.product_container) {
        const selected_set_images = this.product_container.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`);
        const selected_set_thumbs = this.product_container.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

        if (this.hideVariants) {
          // Product images
          this.product_container.querySelectorAll('.product-images__slide').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
              // Also remove active from variant items
              const variantItem = thumb.querySelector('.product-images__slide-item--variant');
              if (variantItem) {
                variantItem.classList.remove('is-active');
              }
            }
          });

          selected_set_images.forEach(thumb => {
            const isActive = thumb.dataset.group === group;
            thumb.classList.toggle('is-active', isActive);
            // Also toggle active for variant items
            const variantItem = thumb.querySelector('.product-images__slide-item--variant');
            if (variantItem) {
              variantItem.classList.toggle('is-active', isActive);
            }
          });

          // Product thumbnails
          this.product_container.querySelectorAll('.product-thumbnail').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });

          selected_set_thumbs.forEach(thumb => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });
        }
      }
    }

    createAvailableOptionsTree(variants, currentlySelectedValues) {
      if (!Array.isArray(variants)) return { option1: [], option2: [], option3: [] };

      // Reduce variant array into option availability tree
      return variants.reduce((options, variant) => {
        if (!variant) return options;

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach((index) => {
          const variantOption = variant[index];
          if (!variantOption) return;

          let entry = options[index].find(option => option.value === variantOption);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = { value: variantOption, isUnavailable: true };
            options[index].push(entry);
          }

          const currentOption1 = currentlySelectedValues?.find(({ index: idx }) => idx === 'option1');
          const currentOption2 = currentlySelectedValues?.find(({ index: idx }) => idx === 'option2');

          switch (index) {
            case 'option1':
              // Option1 inputs should always remain enabled based on all available variants
              entry.isUnavailable = !variant.available;
              break;
            case 'option2':
              // Option2 inputs should remain enabled based on available variants that match first option group
              if (currentOption1 && variant.option1 === currentOption1.value) {
                entry.isUnavailable = !variant.available;
              }
              break;
            case 'option3':
              // Option 3 inputs should remain enabled based on available variants that match first and second option group
              if (currentOption1 && variant.option1 === currentOption1.value &&
                currentOption2 && variant.option2 === currentOption2.value) {
                entry.isUnavailable = !variant.available;
              }
          }
        });

        return options;
      }, { option1: [], option2: [], option3: [] });
    }

    getVariantData() {
      if (!this.variantData) {
        const jsonElement = this.querySelector('[type="application/json"]');
        if (jsonElement) {
          try {
            const parsedData = JSON.parse(jsonElement.textContent || '{}');
            // Check if parsedData is already an array of variants
            if (Array.isArray(parsedData)) {
              // Direct array of variants (from product-information.liquid)
              this.variantData = parsedData;
            } else {
              // Object with variants property (from other templates)
              this.variantData = Array.isArray(parsedData.variants) ? parsedData.variants : [];
            }
          } catch (error) {
            console.error('Error parsing variant data:', error);
            this.variantData = [];
          }
        } else {
          // Fallback to an empty array if no JSON data is found
          this.variantData = [];
        }
      }
      return this.variantData;
    }

    /**
     * Updates the selected styles for all options, specifically handling German locale
     * @returns {void}
     */
    updateSelectedStyles() {
      // Check if we're in German locale
      const isGermanLocale = document.documentElement.lang === 'de';

      // Update all option types in each fieldset
      this.fieldsets.forEach((fieldset) => {
        // Handle select dropdowns
        const selectElements = fieldset.querySelectorAll('select, .single-option-selector');
        selectElements.forEach((select) => {
          const selectedValue = select.value;

          // Update custom styled select displays
          const customSelect = select.closest('.custom-select, .select-wrapper');
          if (customSelect) {
            const displayElement = customSelect.querySelector('.custom-select__display, .select-display');
            const selectedOption = select.querySelector(`option[value="${selectedValue}"]`);
            if (displayElement && selectedOption) {
              displayElement.textContent = selectedOption.textContent;
            }
          }
        });

        // Handle radio buttons (including German-specific styles)
        const radioInputs = fieldset.querySelectorAll('input[type="radio"]');
        radioInputs.forEach((input) => {
          this.updateOptionStyle(input);
        });

        // Handle checkbox buttons
        const checkboxInputs = fieldset.querySelectorAll('input[type="checkbox"]');
        checkboxInputs.forEach((input) => {
          this.updateOptionStyle(input);
        });

        // Handle German-specific custom options (like button-style variants)
        if (isGermanLocale) {
          const germanOptionGroups = fieldset.querySelectorAll('.variant-option-group, .de-variant-options');
          germanOptionGroups.forEach((group) => {
            const options = group.querySelectorAll('.variant-option, .de-variant-option');
            const selectedValue = fieldset.querySelector('input:checked')?.value;

            options.forEach((option) => {
              const optionValue = option.dataset.value || option.querySelector('input')?.value;
              option.classList.toggle('is-selected', optionValue === selectedValue);
              option.classList.toggle('selected', optionValue === selectedValue);
            });
          });
        }
      });

      // Additional handling for global variant options
      const variantRadios = document.querySelectorAll('variant-radios');
      variantRadios.forEach((radiosElement) => {
        const inputs = radiosElement.querySelectorAll('input[type="radio"]');
        inputs.forEach((input) => {
          this.updateOptionStyle(input);
        });
      });
    }

    /**
     * Updates the style for a single option element, handling both standard and custom styles
     * @param {HTMLElement} input - The input element to update
     * @param {boolean} [isDisabled] - Whether the option is disabled
     * @returns {void}
     */
    updateOptionStyle(input, isDisabled) {
      // Find all related elements
      const label = document.querySelector(`label[for="${input.id}"]`);
      const optionWrapper = input.closest('.variant-option, .option-select, .swatch-option, .de-variant-option, .option-item');
      const inputWrapper = input.closest('.input-wrapper, .form-item');

      // Check if input is checked (for radio/checkbox) or selected (for other types)
      const isSelected = input.checked || input.selected;

      // Handle label styles (most common case)
      if (label) {
        label.classList.toggle('is-selected', isSelected);
        label.classList.toggle('checked', isSelected);
        label.classList.toggle('selected', isSelected);

        // Add/remove focus styles if applicable
        label.classList.toggle('is-focused', input === document.activeElement);
        label.classList.toggle('focused', input === document.activeElement);

        // Handle disabled state if specified
        if (isDisabled !== undefined) {
          label.classList.toggle('is-disabled', isDisabled);
          label.classList.toggle('disabled', isDisabled);
          label.classList.toggle('unavailable', isDisabled);
        }
      }

      // Handle wrapper styles (for custom styled options)
      if (optionWrapper) {
        optionWrapper.classList.toggle('is-selected', isSelected);
        optionWrapper.classList.toggle('checked', isSelected);
        optionWrapper.classList.toggle('selected', isSelected);

        // Handle German-specific classes
        if (document.documentElement.lang === 'de') {
          optionWrapper.classList.toggle('de-selected', isSelected);
          optionWrapper.classList.toggle('de-checked', isSelected);
        }

        // Handle disabled state if specified
        if (isDisabled !== undefined) {
          optionWrapper.classList.toggle('is-disabled', isDisabled);
          optionWrapper.classList.toggle('disabled', isDisabled);
          optionWrapper.classList.toggle('unavailable', isDisabled);
        }
      }

      // Handle input wrapper styles
      if (inputWrapper) {
        inputWrapper.classList.toggle('is-selected', isSelected);
        inputWrapper.classList.toggle('selected', isSelected);

        if (isDisabled !== undefined) {
          inputWrapper.classList.toggle('is-disabled', isDisabled);
          inputWrapper.classList.toggle('disabled', isDisabled);
        }
      }

      // Handle direct input styles (for custom styled inputs)
      input.classList.toggle('is-selected', isSelected);
      input.classList.toggle('selected', isSelected);

      if (isDisabled !== undefined) {
        input.classList.toggle('is-disabled', isDisabled);
        input.classList.toggle('disabled', isDisabled);
      }
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        const checkedRadio = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find((radio) => radio && radio.checked);
        return checkedRadio ? (checkedRadio.value || '') : '';
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    product_container;
    thumbnail_container;
    video_containers;
    hide_variants;
    thumbnails;
    prev_button;
    next_button;
    options;
    flkty;
    selectedIndex;
    links;
    pswpElement;
    pswpOptions;
    items;
    activeImages;

    constructor() {
      super();
      // Initialize properties
      this.product_container = null;
      this.thumbnail_container = null;
      this.video_containers = null;
      this.hide_variants = false;
      this.thumbnails = [];
      this.prev_button = null;
      this.next_button = null;
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide'
      };
      this.flkty = null;
      this.selectedIndex = 0;
      this.links = null;
      this.pswpElement = null;
      this.pswpOptions = null;
      this.items = null;
      this.addEventListener('change', this.setupProductGallery);
    }
    /**
     * Called when the element is connected to the DOM
     * @returns {void}
     */
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      // Add null check to prevent errors in test environments
      if (this.product_container) {
        this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
        this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

        this.setOptions();
        // Start Slider
        this.init();
      }
    }
    /**
     * Sets up the slider options
     * @returns {void}
     */
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container ? Array.from(this.thumbnail_container.querySelectorAll('.product-thumbnail')) : [];
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide'
      };
    }
    /**
     * Initializes the slider
     * @returns {void}
     */
    init() {
      if (typeof Flickity !== 'undefined') {
        this.flkty = new Flickity(this, this.options);

        this.selectedIndex = this.flkty.selectedIndex;

        // Setup Events
        this.setupEvents();

        // Start Gallery
        this.setupProductGallery();
      }
    }
    /**
     * Re-initializes the slider
     * @param {number} [imageSetIndex] - Optional image set index
     * @returns {void}
     */
    reInit(imageSetIndex) {
      if (this.flkty) {
        this.flkty.destroy();

        this.setOptions();

        this.flkty = new Flickity(this, this.options);

        // Setup Events
        this.setupEvents();

        this.selectedIndex = this.flkty.selectedIndex;
      }
    }
    /**
     * Sets up event listeners for the slider
     * @returns {void}
     */
    setupEvents() {
      const _this = this;
      if (this.prev_button && this.flkty) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode?.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          this.flkty.previous();
        });
        prev.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button && this.flkty) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode?.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          this.flkty.next();
        });
        next.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers?.forEach((container) => {
        const button = container.querySelector('button');
        if (button) {
          button.addEventListener('click', function () {
            container.setAttribute('hidden', '');
          });
        }
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        // Add null checks to prevent errors
        if (!this.flkty.cells || !this.flkty.cells[index]) return;

        let previous_slide = this.flkty.cells[index].element,
          previous_media = previous_slide?.querySelector('.product-single__media'),
          active_thumb;

        // Check if we're on German locale and using German images
        const isGermanLocale = document.documentElement.lang === 'de';
        const hasGermanImages = this.product_container?.querySelector('[data-media-id*="de-"]');

        // For German locale with custom images, use the direct index
        if (isGermanLocale && hasGermanImages) {
          // Use the clicked thumbnail index if available, otherwise use the current slide index
          const targetIndex = this.clickedThumbnailIndex !== undefined ? this.clickedThumbnailIndex : index;
          // Reset the clicked thumbnail index
          this.clickedThumbnailIndex = undefined;

          // Get the thumbnail corresponding to the target index
          active_thumb = this.thumbnails[targetIndex];
          if (active_thumb) {
            // Update the thumbnail active state
            this.thumbnails.forEach((item) => {
              item.classList.remove('is-initial-selected');
            });
            active_thumb.classList.add('is-initial-selected');
          }
        } else {
          // Remove is-initial-selected from all thumbnails first
          this.thumbnails.forEach((item) => {
            item.classList.remove('is-initial-selected');
          });

          // Original logic for non-German locales or German without custom images
          const active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active'));
          active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

          if (active_thumb) {
            active_thumb.classList.add('is-initial-selected');
          }
        }

        requestAnimationFrame(() => {
          if (active_thumb.offsetParent === null) {
            return;
          }
          const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
            windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
          active_thumb.parentElement?.scrollTo({
            left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
            top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
            behavior: 'smooth'
          });
        });

        // Stop previous video
        if (previous_media?.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            const iframe = previous_media.querySelector('iframe');
            if (iframe?.contentWindow) {
              iframe.contentWindow.postMessage(JSON.stringify({
                event: "command",
                func: "pauseVideo",
                args: ""
              }), "*");
            }
          } else if (previous_media.dataset.provider === 'vimeo') {
            const iframe = previous_media.querySelector('iframe');
            if (iframe?.contentWindow) {
              iframe.contentWindow.postMessage(JSON.stringify({
                method: "pause"
              }), "*");
            }
          }
          const playButton = previous_media.querySelector('.product-single__media-external-video--play');
          if (playButton) {
            playButton.removeAttribute('hidden');
          }
        } else if (previous_media?.classList.contains('product-single__media-native-video')) {
          const video = previous_media.querySelector('video');
          if (video) {
            video.pause();
          }
        }

      });


      setTimeout(() => {
        let active_thumbs = Array.from(this.thumbnails).filter(element => element && element.clientWidth > 0);
        active_thumbs.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', () => {
            this.thumbnailClick(thumbnail, index);
          });

          // Add click event listener for play button
          const playButton = thumbnail.querySelector('.product-thumbnail-icon');
          if (playButton) {
            playButton.addEventListener('click', (e) => {
              // Prevent event from bubbling to the thumbnail
              e.stopPropagation();

              // Select the corresponding slide
              this.thumbnailClick(thumbnail, index);

              // After a short delay, find and play the video
              setTimeout(() => {
                // Get the current active slide
                const activeSlide = this.flkty.selectedElement;
                if (activeSlide) {
                  // Check if it's a deferred media component
                  const deferredMedia = activeSlide.querySelector('deferred-media');
                  if (deferredMedia) {
                    // If it's a deferred media component, use its playMedia method
                    deferredMedia.playMedia();
                  } else {
                    // For native video (German version), find and play the video element
                    const video = activeSlide.querySelector('video');
                    if (video) {
                      video.play();
                    }
                  }
                }
              }, 100);
            });
          }
        });
      });

    }
    /**
     * Handles thumbnail click events
     * @param {HTMLElement} thumbnail - The clicked thumbnail element
     * @param {number} index - The index of the thumbnail
     * @returns {void}
     */
    thumbnailClick(thumbnail, index) {
      // Check if we're on German locale and using German images
      const isGermanLocale = document.documentElement.lang === 'de';
      const hasGermanImages = this.product_container?.querySelector('[data-media-id*="de-"]');

      // For German locale with custom images, use the direct index
      if (isGermanLocale && hasGermanImages) {
        // Store the clicked thumbnail index for use in the change event
        this.clickedThumbnailIndex = index;
        // Select the corresponding slide in Flickity
        this.flkty.select(index);
      } else {
        // Original logic for non-German locales or German without custom images
        const active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active'));
        const targetIndex = active_thumbs[index] ? index : 0;

        // First, remove is-initial-selected from all thumbnails
        this.thumbnails.forEach((item) => {
          item.classList.remove('is-initial-selected');
        });
        // Add is-initial-selected to the clicked thumbnail
        thumbnail.classList.add('is-initial-selected');

        this.flkty.select(targetIndex);
      }
    }
    /**
     * Sets whether the slider is draggable
     * @param {boolean} draggable - Whether to enable dragging
     * @returns {void}
     */
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    /**
     * Selects a cell in the slider
     * @param {number|string} mediaId - The ID or index of the media to select
     * @returns {void}
     */
    selectCell(mediaId) {
      // Check if mediaId is a number (index) or string (ID)
      if (this.flkty) {
        if (typeof mediaId === 'number') {
          // If it's a number, use Flickity's select method
          this.flkty.select(mediaId);
        } else {
          // If it's a string selector, find the index first
          const slides = this.querySelectorAll('.product-images__slide');
          let index = 0;
          slides.forEach((slide, i) => {
            if (slide.querySelector(mediaId)) {
              index = i;
            }
          });
          this.flkty.select(index);
        }
      }
    }
    /**
     * Sets up the product gallery
     * @returns {void}
     */
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom')?.length) {
        return;
      }
      this.setEventListeners();
    }
    /**
     * Builds the items array for the photo gallery
     * @returns {Array} - Array of gallery items
     */
    buildItems() {
      // Check if we're on German locale and using German images
      const isGermanLocale = document.documentElement.lang === 'de';
      const hasGermanImages = this.querySelector('[data-media-id*="de-"]');
      let slidesToProcess;
      let items = [];

      if (isGermanLocale && hasGermanImages) {
        // For German locale with custom images, get all German slides
        slidesToProcess = Array.from(this.querySelectorAll('[data-media-id*="de-"]'));
      } else {
        // Original logic for non-German locales or German without custom images
        slidesToProcess = Array.from(this.querySelectorAll('.product-images__slide.is-active'));
      }

      slidesToProcess.forEach((slide, slideIdx) => {
        // For German locale, check if the slide has multiple images in its dataset
        if (isGermanLocale && hasGermanImages) {
          // Get all zoom links in this slide
          const zoomLinks = slide.querySelectorAll('.product-single__media-zoom');

          // If there are multiple zoom links, treat them as separate items
          if (zoomLinks.length > 1) {
            zoomLinks.forEach((link, linkIdx) => {
              const index = items.length; // Use the global items array index
              link.dataset.index = index.toString();

              items.push({
                src: link.getAttribute('href'),
                msrc: link.dataset.msrc,
                w: parseInt(link.dataset.w, 10),
                h: parseInt(link.dataset.h, 10)
              });
            });
          } else {
            // Single image case
            const activelink = slide.querySelector('.product-single__media-zoom');
            const index = items.length;

            if (activelink) {
              activelink.dataset.index = index.toString();

              items.push({
                src: activelink.getAttribute('href'),
                msrc: activelink.dataset.msrc,
                w: parseInt(activelink.dataset.w, 10),
                h: parseInt(activelink.dataset.h, 10)
              });
            }
          }
        } else {
          // Original logic for non-German locales or German without custom images
          const index = [].indexOf.call(this.querySelectorAll('.product-images__slide.is-active'), slide);
          const activelink = slide.querySelector('.product-single__media-zoom');

          if (activelink) {
            activelink.dataset.index = index.toString();

            items.push({
              src: activelink.getAttribute('href'),
              msrc: activelink.dataset.msrc,
              w: parseInt(activelink.dataset.w, 10),
              h: parseInt(activelink.dataset.h, 10)
            });
          }
        }
      });

      return items;
    }
    /**
     * Sets up event listeners for the gallery
     * @returns {void}
     */
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];

      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail?.getBoundingClientRect();
          return {
            x: rect?.left || 0,
            y: (rect?.top || 0) + pageYScroll,
            w: rect?.width || 0
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    /**
     * Handles click on zoom links
     * @param {Event} e - The click event
     * @param {HTMLElement} link - The clicked link element
     * @returns {void}
     */
    zoomClick(e, link) {
      this.items = this.buildItems();

      // Find the index of the clicked item in the items array
      let clickedIndex = 0;
      this.items.forEach((item, index) => {
        if (item.src === link.getAttribute('href')) {
          clickedIndex = index;
        }
      });

      this.pswpOptions.index = clickedIndex;

      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        document.body.classList.add('open-lightbox');
        pswp.listen('firstUpdate', function () {
          pswp.listen('destroy', function () {
            document.body.classList.remove('open-lightbox');
          });
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = null;
      this.cartNotification = null;
      this.body = document.body;
      this.hideErrors = false;
      this.sticky = '';
    }
    connectedCallback() {
      this.sticky = this.dataset?.sticky || '';
      this.form = document.getElementById(`product-form-${this.dataset?.section || ''}`);
      if (this.form) {
        const idInput = this.form.querySelector('[name=id]');
        if (idInput) {
          idInput.disabled = false;
        }
        if (!this.sticky) {
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
      }
      this.cartNotification = document.querySelector('cart-notification');

      this.hideErrors = this.dataset?.hideErrors === 'true';
    }
    onSubmitHandler(evt) {
      evt.preventDefault();

      if (!this.form.reportValidity()) {
        return;
      }

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };


      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));

      let product_drawer = document.getElementById('Product-Drawer'),
        search_drawer = document.getElementById('Search-Drawer');

      if (search_drawer.classList.contains('active')) {
        search_drawer.classList.remove('active');
      }
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.classList.remove('active');
        this.body.classList.remove('open-cc--product');
        if (document.getElementById('Cart-Drawer')) {
          document.getElementById('Cart-Drawer').open();
        }
      } else if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    setupToggle() {
      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button.addEventListener('click', function () {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener('click', function () {
          content.classList.toggle('active');
          return false;
        });
      }

    }
    setupObservers() {
      let _this = this,
        form = document.getElementById(`product-form-${this.dataset?.section || ''}`),
        footer = document.getElementById('footer');

      const observer = new IntersectionObserver(function (entries) {
        entries.forEach((entry) => {
          if (footer && entry.target === footer) {
            if (entry.intersectionRatio > 0) {
              _this.classList.remove('sticky--visible');
            } else if (entry.intersectionRatio == 0 && _this.formPassed) {
              _this.classList.add('sticky--visible');
            }
          }
          if (form && entry.target === form) {
            let boundingRect = form.getBoundingClientRect();

            if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
              _this.formPassed = true;
              _this.classList.add('sticky--visible');
            } else if (entry.intersectionRatio === 1) {
              _this.formPassed = false;
              _this.classList.remove('sticky--visible');
            }
          }
        });
      }, {
        threshold: [0, 1]
      });

      _this.formPassed = false;
      if (form) {
        observer.observe(form);
      }
      if (footer) {
        observer.observe(footer);
      }
      if (footer) {
        observer.observe(footer);
      }
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {

    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.body.classList.add('open-cc');
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add('active');
        });
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}